export enum CurrentLocationMode {
  NONE = "NONE",
  COORDS = "COORDS",
  IP = "IP",
}

export type CurrentLocation = {
  city?: string | null;
  abbr?: string | null;
  mode: CurrentLocationMode;
};

export type CurrentLocationCoords = {
  latitude?: number | null;
  longitude?: number | null;
};
